define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/action/Controller",
	"csi/middleware/customView/customViewValidateService",
	"csi/prefs",
	"csi/util",
	"csi/xml"
], function(declare, _, Controller, {writeMigrationKeyReportOperations}, prefs, util, xml) {

	return declare(Controller, {
		/**
		 * @override
		 * Ensure that all results are loaded on page
		 */
		onPreActionDeferreds(dfds) {
			dfds.push(this.widget.queryMoreToTarget(true));
		},

		/**
		 * @override
		 * output XML script of all errors
		 */
		process() {
			var view = this.widget;
			var w = this.m_writer;
			var query;
			var wn;
			
			const fd = this.m_formData;
			const customerName = fd.getFieldValue("Customer Name");
			const jiraID = fd.getFieldValue("Jira Id");
			const sectionComment = jiraID + " " + customerName;
			
			// first, delete all orphans
			w.addComment("Delete Orphan / Outdated Views");
			var orphans = _.keys(view._mapOrphans);
			if (orphans.length) {
				w.deleteList(orphans, null, null, true);
				w.flushChanges();
			}

			// second, output ops to resolve moved custom views
			w.addComment("Resolve Views");

			_.each(view._mapMoves, function(url, key) {
				w.callMethod("SiteAdmin", "MoveCustomViews")
					.addParameter("FromContainerURL", xml.ATTR_REF, url)
					.addParameter("ToContainerURL", xml.ATTR_REF, "");

				w.flushChanges();
			});

			// third, output ops to fix nested view errors
			w.addComment("Resolve Nested Views");

			_.each(view._mapNested, function(nestedViewKeys, keyView) {
				query = w.createQuery();
				query.And()
					.Node(xml.PROP_TYPE, xml.OP_EQUALS, prefs.TYPE_VIEW)
					.RefAttr(xml.ATTR_PARENT, xml.OP_EQUALS, prefs.URL_PREFIX + keyView);

				wn = w.changeQuery(query);

				_.each(_.keys(nestedViewKeys).sort(), function(key) {
					wn.searchAndReplace("NestedViews", "^" + key.replace(/\|/g, "\\|").replace(/\^/g, "\\^") + "$", "", true);
				});

				w.flushChanges();
			});

			// fourth, output ops to fix missing TargetClass on CVs
			w.addComment("Resolve TargetClass");

			_.each(view._mapTargetClasses, (targetType, cnl) => {
				const cn = w.changeNode(cnl);
				cn.changeAttribute("TargetClass", xml.ATTR_STRING, targetType);
			});
			
			w.flushChanges();

			// last, output ops to migrate keys with issues
			_.each(_.keys(view._mapKeyReports).sort(), (targetClass) => {
				const report = view._mapKeyReports[targetClass];
				writeMigrationKeyReportOperations(w, targetClass, report, false, sectionComment);
			});

			var win = open("", "Custom View Migration");
			if (win) {
				win.document.write("<HTML><HEAD><TITLE>Custom View Migration</TITLE></HEAD>");
				win.document.write("<BODY><pre>" + util.xmlToString(util.serializeXML(w.doc)) + "</pre></BODY></HTML>");
				win.document.close();
			}

			view.resetMigration();
			this.postProcess();
		}
	});
});